import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import animated from "animate.css";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import "vant/lib/index.css";
import useDebounce from "./utils/uroadUtils/useDebounce";
// import VConsole from "vconsole";
// new VConsole();
const Vue = createApp(App);
// main.js
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  Vue.component(key, component);
}
//rem适配插件
import "./utils/flexible";

import {
  Tab,
  Tabs,
  Collapse,
  CollapseItem,
  Field,
  Dialog,
  Button,
  DropdownMenu,
  DropdownItem,
  Icon,
  Notify,
  SwipeCell,
} from "vant";
Vue.directive("debounce", useDebounce);
Vue.use(Tab);
Vue.use(SwipeCell);
Vue.use(Tabs);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Field);
Vue.use(Dialog);
Vue.use(Button);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Icon);
Vue.use(Notify);
Vue.use(SwipeCell);

// 全局封装类统一注入
import uroadUtils from "./utils/uroadUtils";
Vue.use(uroadUtils);
Vue.use(animated);
Vue.use(ElementPlus);
router.beforeEach(function (to, from, next) {
  if (!!to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

Vue.use(store).use(router).mount("#app");
